import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { useRootStore } from 'stores/RootStore'
import { Action, ActionProps } from './Action'
import cx from 'classnames'
import { BlogMetadata as BlogMetadataIcon } from 'blaze-ui/icons/36/BlogMetadata'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Wrench } from 'blaze-ui/icons'

export const BlogMetadata = observer(({ className, ...props }: ActionProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { rightRailPanelStore } = useRootStore()
  const docStore = useDocStore()

  const handleClick = () => {
    if (isSystemRedesignEnabled) {
      docStore?.rightRailStore.setActiveTab('Metadata')
    } else {
      docStore?.rightRailStore.setActiveTab(undefined)
      rightRailPanelStore.show('blog_metadata')
    }
  }

  return (
    <Action
      {...props}
      className={cx(className)}
      icon={isSystemRedesignEnabled ? Wrench : BlogMetadataIcon}
      onPress={handleClick}
      isDisabled={!!docStore.isGeneratingSuggestion}
    />
  )
})
